import { languageChanged } from './userContextStore';
import { apiGet, apiPost, getAuthorization, getHostApi, getHostUrl, getLanguage } from './apiWrapper';
import textVersion from 'textversionjs'
import XRegExp from 'xregexp';
import * as signalR from '@microsoft/signalr';
import { isRepiWeb, reloadApiVersion } from './storeFunctions';
import { toastNotification } from '../components/common/toast';
import { getTranslate } from 'react-localize-redux';
import { isFunction } from 'formik';
import { writeDebug, writeErr } from '../components/common/logger';

const loadNews = "LOAD_NEWS";
const processNews = "PROCESS_NEWS";
const processNewsError = "PROCESS_NEWS_ERROR";
const loadNewsCheck = "LOAD_NEWS_CHECK";
const processNewsCheck = "PROCESS_NEWS_CHECK";
const processNewsCheckError = "PROCESS_NEWS_CHECK_ERROR";
const loadNotifications = "LOAD_NOTIFICATIONS";
const processNotifications = "PROCESS_NOTIFICATIONS";
const processNotificationsError = "PROCESS_NOTIFICATIONS_ERROR";
const loadPaged = "LOAD_PAGED";
const processPaged = "PROCESS_PAGED";
const processPagedError = "PROCESS_PAGED_ERROR";
const updateNotificationsStatus = "UPDATE_NOTIFICATION_STATUS";
const updatingNotification = "UPDATING_NOTIFICATION";
const updateNotificationSeen = "UPDATE_NOTIFICATION_SEEN";
const updateNotificationDismissed = "UPDATE_NOTIFICATION_DISMISSED";
const updateNotificationCount = "UPDATE_NOTIFICATION_COUNT";
const loadedOlderNotifications = "LOADED_NOTIFICATION_OLDER";
const pushNotification = "PUSH_NOTIFICATION";
const connectionStarted = "CONNECTION_STARTED";
const connectionStopped = "CONNECTION_STOPPED";
const logoutNotifications = "LOGOUT_NOTIFICATIONS";
const setMaxNotifId = "SET_MAX_NOTIFICATION_ID"

const signalNotificationUpdate = "UPDATE_NOTIFICATION_SIGNALR_PUSH";
const signalNotificationAdd = "ADD_NOTIFICATION_SIGNALR_PUSH";

const initialState = {
    isLoading: false,
    isLoadingCheck: false,
    isLoadingNotif: false,
    isLoadingPaged: false,
    data: null,
    dataCheck: null,
    dataNotif: null,
    error: null,
    errorCheck: null,
    errorNotif: null,
    dataPaged: null,
    errorPaged: null,
    page: null,
    totalCount: 0,
    totalCountPage: 0,
    dropdownSize: 0,
    pageSize: 0,
    languageChanged: false,
    hubConnection: null,
    connLang: "",
    connOpen: false,
    maxNotificationId: -1,
    loadOlderNotifications: 0,
    pageReloadNeeded: false
};

const functionsSignalR = isRepiWeb() ? [
    { method: 'RepiNotificationSync', stateItem: 'news', handler: RepiNotificationSyncHandler },
    { method: 'ApiVersionSync', stateItem: 'news', handler: ApiVersionSyncHandler }
] : [
    { method: 'NotificationSync', stateItem: 'news', handler: NotificationSyncHandler },
    { method: 'ApiVersionSync', stateItem: 'news', handler: ApiVersionSyncHandler }
];

const handlersSignalR = isRepiWeb() ? {
    internal: {},
    ['OlderRepiNotifications'.toLowerCase()]: { stateItem: 'news', handler: OlderNotificationsProcess },
    ['RepiNotifSyncData'.toLowerCase()]: { stateItem: 'news', handler: NotifSyncDataProcess },
    ['MaxRepiNotificationId'.toLowerCase()]: { stateItem: 'news', handler: MaxNotificationIdProcess },
    ['ConnectionId'.toLowerCase()]: { stateItem: 'news', handler: ConnectionIdProcess }
} : {
    internal: {
        //getState
        //dispatch
    },
    ['OlderNotifications'.toLowerCase()]: { stateItem: 'news', handler: OlderNotificationsProcess },
    ['NotifSyncData'.toLowerCase()]: { stateItem: 'news', handler: NotifSyncDataProcess },
    ['MaxNotificationId'.toLowerCase()]: { stateItem: 'news', handler: MaxNotificationIdProcess },
    ['ConnectionId'.toLowerCase()]: { stateItem: 'news', handler: ConnectionIdProcess }
}

function getCurrentIds(state) {
    let currentIds = [];
    if (state.dataNotif !== null && state.dataNotif !== undefined)
        currentIds = state.dataNotif.filter(x => x.notification !== null && x.notification !== undefined).map(x => x.notification.id);
    return currentIds;
}

function NotificationSyncHandler(dispatch, state, hub, maxId) {
    hub.invoke('GetNotifSyncData', getCurrentIds(state), state.maxNotificationId).then(signalWrap);
}

function RepiNotificationSyncHandler(dispatch, state, hub, maxId) {
    hub.invoke('GetRepiNotifSyncData', getCurrentIds(state), state.maxNotificationId).then(signalWrap);
}

function ApiVersionSyncHandler(dispatch, state, hub, version) {
    reloadApiVersion(version);
}

function NotifSyncDataProcess(dispatch, state, data) {
    dispatch({ type: updateNotificationCount, count: data.count })
    if (data.update !== null && data.update !== undefined && data.update.length > 0) {
        dispatch({ type: signalNotificationUpdate, updated: data.update });
    }
    if (data.new !== null && data.new !== undefined && data.new.length > 0) {
        dispatch({ type: signalNotificationAdd, added: data.new });
    }
}

function OlderNotificationsProcess(dispatch, state, data) {
    dispatch({ type: updateNotificationCount, count: data.count })
    if (data.old !== null && data.old !== undefined, data.old.length > 0) {
        dispatch({ type: loadedOlderNotifications, older: data.old })
    }
}

function MaxNotificationIdProcess(dispatch, state, data) {
    dispatch({ type: setMaxNotifId, maxNotifId: data })
}
function ConnectionIdProcess(dispatch, state, data) {
    state.hubConnection.id = data;
}

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case languageChanged:
            return {
                ...state, isLoading: false, data: null, error: null,
                isLoadingNotif: false, dataNotif: null, errorNotif: null,
                isLoadingPaged: false, languageChanged: true
            };
        case loadNews:
            return { ...state, isLoading: true, data: null, error: null, languageChanged: false };
        case processNews:
            return { ...state, isLoading: false, data: action.news, error: null, languageChanged: false };
        case processNewsError:
            return { ...state, isLoading: false, data: null, error: action.error, languageChanged: false };
        case loadNewsCheck:
            return { ...state, isLoadingCheck: true, dataCheck: null, errorCheck: null, languageChanged: false };
        case processNewsCheck:
            return { ...state, isLoadingCheck: false, dataCheck: action.news, errorCheck: null, languageChanged: false };
        case processNewsCheckError:
            return { ...state, isLoadingCheck: false, dataCheck: null, errorCheck: action.error, languageChanged: false };
        case loadNotifications:
            return { ...state, isLoadingNotif: true, dataNotif: null, errorNotif: null, languageChanged: false };
        case processNotifications:
            return {
                ...state, isLoadingNotif: false, dataNotif: action.notifications, errorNotif: null, languageChanged: false,
                totalCount: action.totalCount, dropdownSize: action.dropdownSize, pageSize: action.pageSize
            };
        case processNotificationsError:
            return { ...state, isLoadingNotif: false, dataNotif: action.errorNotifications, errorNotif: action.error, languageChanged: false, totalCount: 'X' };
        case updateNotificationsStatus:
            return { ...state, dataNotif: action.notifications, totalCount: action.isSeen ? state.totalCount - 1 : state.totalCount, pageReloadNeeded: true, errorNotif: null, languageChanged: false };
        case pushNotification:
            return {
                ...state, dataNotif: action.data, totalCount: state.totalCount + action.diff,
                errorNotif: null, languageChanged: false
            };
        case connectionStarted:
            return { ...state, hubConnection: action.hubConnection, connLang: action.connLang, connOpen: true, languageChanged: false }
        case connectionStopped:
            return { ...state, hubConnection: null, connLang: "", connOpen: false }
        case loadPaged:
            return { ...state, isLoadingPaged: true, errorPaged: null, languageChanged: false, page: action.page };
        case processPaged:
            return { ...state, isLoadingPaged: false, dataPaged: action.notifications, errorPaged: null, languageChanged: false, totalCountPage: action.totalCountPage, pageReloadNeeded: false };
        case processPagedError:
            return { ...state, isLoadingPaged: false, dataPaged: null, errorPaged: action.error, languageChanged: false };
        case setMaxNotifId:
            return { ...state, maxNotificationId: action.maxNotifId }
        case logoutNotifications:
            return initialState;
        case updateNotificationCount:
            return { ...state, totalCount: action.count, pageReloadNeeded: state.totalCount !== action.count };
        case updateNotificationSeen:
            return {
                ...state, dataNotif: (state.dataNotif === null || state.dataNotif === undefined) ? state.dataNotif : state.dataNotif.map(x => {
                    if (x.notification === null || x.notification === undefined || x.notification.id !== action.notificationId) return x;
                    return { ...x, notification: { ...x.notification, seen: true, processing: false } };
                }), dataPaged: (state.dataPaged === null || state.dataPaged === undefined) ? state.dataPaged : state.dataPaged.map(x => {
                    if (x.notification === null || x.notification === undefined || x.notification.id !== action.notificationId) return x;
                    return { ...x, notification: { ...x.notification, seen: true, processing: false } };
                })
            };
        case updateNotificationDismissed: {
            const dataNotifCurrent = (state.dataNotif === null || state.dataNotif === undefined) ? state.dataNotif : state.dataNotif.filter(x => x.notification === null || x.notification === undefined || x.notification.id !== action.notificationId);
            const loadOlderNotifications = Math.max(0, state.dropdownSize - (dataNotifCurrent || []).filter(x => x.notification !== null && x.notification !== undefined).length);
            const dataPaged = (state.dataPaged === null || state.dataPaged === undefined) ? state.dataPaged : state.dataPaged.filter(x => x.notification === null || x.notification === undefined || x.notification.id !== action.notificationId);
            return { ...state, dataNotif: dataNotifCurrent, loadOlderNotifications, dataPaged, pageReloadNeeded: true };
        }
        case updatingNotification:
            return {
                ...state, dataNotif: (state.dataNotif === null || state.dataNotif === undefined) ? state.dataNotif : state.dataNotif.map(x => {
                    if (x.notification === null || x.notification === undefined || x.notification.id !== action.notificationId) return x;
                    return { ...x, notification: { ...x.notification, processing: action.processing } };
                }), dataPaged: (state.dataPaged === null || state.dataPaged === undefined) ? state.dataPaged : state.dataPaged.map(x => {
                    if (x.notification === null || x.notification === undefined || x.notification.id !== action.notificationId) return x;
                    return { ...x, notification: { ...x.notification, processing: action.processing } };
                })
            };
        case signalNotificationUpdate: {
            let notifs = [];
            let runRing = false;
            if (state.dataNotif !== null && state.dataNotif !== undefined) {
                for (let i = 0; i < state.dataNotif.length; i++) { // add only not seen notifications if they are above configured limit
                    const up = action.updated.filter(u => u.id == (state.dataNotif[i].notification || {}).id)[0];

                    if (up === null || up === undefined) { // for nonupdated messages - remove if it is already seen and is above configured limit
                        if (notifs.length >= state.dropdownSize) { continue; }
                        notifs.push(state.dataNotif[i]);
                    } else {
                        if (up.dissmissed) { continue; }
                        runRing = true;

                        if (notifs.length >= state.dropdownSize) { continue; } // for update messages - remove if it is already seen and is above configured limit
                        notifs.push({ ...state.dataNotif[i], notification: { ...state.dataNotif[i].notification, seen: up.seen, dissmissed: up.dissmissed } })
                    }
                }
                if (runRing) ringTheBell();
            }
            return { ...state, dataNotif: notifs };
        }
        case signalNotificationAdd: {
            let notifs = []; // reorder is needed to have new messages on top of stack
            let runRing = false;
            var dataNotif = state.dataNotif || [];
            // first insert new notifications

            const loopMax = Math.min(action.added.length, state.dropdownSize);
            for (let i = 0; i < loopMax; i++) {
                if (dataNotif.filter(x => (x.notification || {}).id === action.added[i].id).length === 0) {
                    toastNotification(action.added[i]);
                    notifs.push({ news: null, notification: action.added[i] });
                    runRing = true;
                }
            }
            // then add old notifications if there is still space
            if (state.dropdownSize > notifs.length) {
                for (let i = 0; i < dataNotif.length; i++) {
                    if (notifs.length >= state.dropdownSize) { continue; }
                    notifs.push(dataNotif[i]);
                }
            }

            // calculate new maxNotificationId (used to mitigate redundant server sync calls)
            const maxCandidates = ((dataNotif || [{ notification: { id: -1 } }])
                .filter(x => x.notification !== null && x.notification !== undefined) || [-1]);
            const maxNotificationId = maxCandidates.length > 2 ? maxCandidates.map(x => x.notification.id).reduce((a, b) => Math.max(a, b))
                : (maxCandidates.length < 1 ? -1 : maxCandidates[0].notification.id);
            if (runRing) ringTheBell();
            return { ...state, dataNotif: notifs, maxNotificationId };
        }
        case loadedOlderNotifications: {
            let current = [...state.dataNotif];
            if (state.dropdownSize > current.length) {
                for (let i = 0; i < action.older.length; i++) {
                    if (current.length >= state.dropdownSize) { continue; }
                    current.push({ news: null, notification: action.older[i] });
                }
            }
            return { ...state, dataNotif: current };
        }
        case 'LOGIN_EXPIRED':
            var hubConnection = state.hubConnection;
            if (hubConnection && state.connOpen) {
                hubConnection.closedCallbacks = [];
                hubConnection
                    .stop()
                    .then(() => console.log('Connection stopped!'))
                    .catch(err => console.log('Error while stopping connection :('));
            }
            return initialState;
        default:
            return state;
    }
}

export const newsActions = {
    ensureNews: () => async (dispatch, getState) => ensureNews(dispatch, getState),
    ensureNewsCheck: () => async (dispatch, getState) => ensureNewsCheck(dispatch, getState),
    ensureNotifications: force => async (dispatch, getState) => ensureNotifications(dispatch, getState, force),
    getNotifications: (page, includeNews, includeNotifications) => async dispatch => getNotifications(dispatch, page, includeNews, includeNotifications),
    updateNotificationsStatus: (status, id, callback) => async (dispatch, getState) => updateNotifStatus(dispatch, getState, status, id, callback),
    updateNewsStatus: (id, callback) => async (dispatch, getState) => updateNewsStatus(dispatch, getState, id, callback),
    pushNotification: (notif) => async (dispatch, getState) => pushNotif(dispatch, getState, notif),
    getTextContent: input => () => getTextContent(input),
    linkClick: (ev, notifId, history) => async (dispatch, getState) => linkClick(dispatch, getState, ev, notifId, history),
    generatePdfLink: id => () => generatePdfLink(id),
    generateMlExportLink: id => () => generateMlExportLink(id),
    generateExportLink: id => () => generateExportLink(id),
    resetConnection: () => (dispatch, getState) => resetConnection(dispatch, getState),
    logoutNotifications: () => (dispatch, getState) => logoutNotifs(dispatch, getState),
    fetchOlderNotifications: () => (dispatch, getState) => getOlderNotifications(dispatch, getState().news)
};

function ensureNews(dispatch, getState) {
    if (getState().news.isLoading === false && !getState().news.data && !getState().news.error) {
        dispatch({ type: loadNews });
        apiGet(`${getHostApi()}/api/account/news`, null,
            res => getState().news.isLoading === false ?
                ensureNews(dispatch, getState) : // language was changed, repeat request
                dispatch({ type: processNews, news: res.data }),
            err => dispatch({ type: processNewsError, error: err })
        );
    }
}

function ensureNewsCheck(dispatch, getState) {
    if (getState().news.isLoadingCheck === false && !getState().news.dataCheck && !getState().news.errorCheck) {
        dispatch({ type: loadNewsCheck });
        apiGet(`${getHostApi()}/api/account/check-news`, null,
            res => dispatch({ type: processNewsCheck, news: res.data }),
            err => dispatch({ type: processNewsCheckError, error: err })
        );
    }
}

function ensureNotifications(dispatch, getState, force) {
    if (force || (getState().news.isLoadingNotif === false && !getState().news.dataNotif && !getState().news.errorNotif)) {
        dispatch({ type: loadNotifications });

        const params = { purpose: 'dropdown' };
        if (isRepiWeb())
            params.onlyRepi = true

        apiGet(`${getHostApi()}/api/account/notifications`, params,
            res => {
                dispatch({
                    type: processNotifications, notifications: res.data.notifications, totalCount: res.data.totalCount,
                    dropdownSize: res.data.dropdownSize, pageSize: res.data.pageSize
                });
            },
            err => dispatch({ type: processNotificationsError, error: err, errorNotifications: [{ notification: { id: -1, description: getTranslate(getState().localize)('UnhappyUser.Notifications'), completed: new Date() } }] }),
            _ => startConnection(dispatch, getState, force)
        );
    }
}

function getNotifications(dispatch, page, includeNews, includeNotifications) {
    dispatch({ type: loadPaged, page: page });

    const params = { purpose: 'page', page: page, includeNews, includeNotifications };
    if (isRepiWeb())
        params.onlyRepi = true

    apiGet(`${getHostApi()}/api/account/notifications`, params,
        res => dispatch({
            type: processPaged, notifications: res.data.notifications, totalCountPage: res.data.totalCount,
            dropdownSize: res.data.dropdownSize, pageSize: res.data.pageSize
        }),
        err => dispatch({ type: processPagedError, error: err })
    );
}

function getOlderNotifications(dispatch, state) {
    let olderThanId = state.maxNotificationId;
    if (state.dataNotif !== null && state.dataNotif !== undefined) {
        const itemList = state.dataNotif.filter(x => x.notification !== null && x.notification !== undefined);
        if (itemList.length > 2) {
            olderThanId = itemList.map(x => x.notification.id).reduce((a, b) => Math.min(a, b));
        } else if (itemList.length === 1) {
            olderThanId = itemList[0].notification.id
        }
    }

    state.hubConnection.invoke('GetOlderNotifications', olderThanId, state.loadOlderNotifications).then(signalWrap);
}

function updateNotifStatus(dispatch, getState, status, id, callback) {
    if (getState().news.isLoadingNotif === false && !getState().news.errorNotif) {
        dispatch({ type: updatingNotification, notificationId: id, processing: true })

        const params = { ...{ statusId: status }, ...((id || id === 0) ? { notificationId: id } : {}) };
        if (isRepiWeb())
            params.onlyRepi = true;

        apiGet(`${getHostApi()}/api/account/update-notification-status`, params,
            res => {
                if (res.data == true) {
                    if (status == 2) {
                        dispatch({ type: updateNotificationSeen, notificationId: id })
                    } else if (status == 3) {
                        dispatch({ type: updateNotificationDismissed, notificationId: id })
                    }
                    if (isFunction(callback)) {
                        callback();
                    }
                } else {
                    dispatch({ type: updatingNotification, notificationId: id, processing: false })
                }
            }
        );
    }
}
function updateNewsStatus(dispatch, getState, ids, callback) {
    apiPost(`${getHostApi()}/api/account/update-news`, undefined, ids,
        res => {
            if (res.data == true) {
                updateNewsSeen(dispatch, getState, ids, callback)
            }
        },
    );
}
function updateNewsSeen(dispatch, getState, id, callback) {
    if (getState().isLoadingNotif)
        setTimeout(function () { //Start the timer
            this.updateNewsSeen(dispatch, getState, id, callback);
        }.bind(this), 500)
    else {
        var data = getState().news.dataNotif;
        if (data.find(o => o.news && o.news.newsId == id))
            data.find(o => o.news && o.news.newsId == id).news.seen = true;
        data = data.slice(); // to see changes
        dispatch({ type: updateNotificationsStatus, notifications: data, isSeen: true });
        if (isFunction(callback)) {
            callback();
        }
    }
}

function pushNotif(dispatch, getState, notif) {
    if (getState().news.isLoadingNotif === false && getState().news.dataNotif && !getState().news.errorNotif) {
        var diff = 1;
        var data = getState().news.dataNotif;
        var count1 = data.length;
        if (notif.newsId) {
            if (data.filter(f => f.news && f.news.newsId == notif.newsId).length == 0) {
                data.unshift({ news: notif, notification: null });
                if (data.length > getState().news.dropdownSize) {
                    data.pop();
                }
                data = data.slice(); // to see changes
                ringTheBell()
                notif.color = "info";
                toastNotification(notif);
                dispatch({ type: pushNotification, data, diff });
            }
            //updated
            else {
                for (var i = 0; i < data.length; i++) {
                    if (data[i].news && data[i].news.newsId === notif.newsId) {
                        var diff = 0;
                        if (data[i].news.seen) {
                            notif.color = "info";
                            toastNotification(notif);
                            diff = 1;
                        }
                        data[i].news = notif;
                        dispatch({ type: pushNotification, data, diff: diff });
                    }
                }
            }
            return;
        }
    }
}

function ringTheBell() {
    counter = 0;
    angle = 0;
    direction = 1;
    if (timer == null && document.getElementById('notif-icon') != null)
        timer = setInterval(ring, 30);
}

var timer = null;
var counter = 0;
var angle = 0;
var direction = 1;

function ring() {
    angle += direction * 15;
    counter++;
    let notif = document.getElementById('notif-icon');
    if (notif !== null && notif !== undefined) {
        notif.style.transform = 'rotate(' + angle + 'deg)';
        if (Math.abs(angle) >= 30)
            direction *= -1;
        if (counter >= 48 && angle == 0) {
            clearInterval(timer);
            timer = null;
        }
    } else {
        clearInterval(timer);
        timer = null;
    }
}

function getTextContent(input) {
    const regexp = XRegExp('<table.*?>.*?<\/\\s*table>', 's');
    const config = { listStyle: "linebreak", linkProcess: function (href, text) { return '<a href="' + href + '">' + text + '</a>'; } };
    return textVersion(XRegExp.replace(input, regexp, ''), config);
}

function linkClick(dispatch, getState, ev, notifId, history) {
    if (ev.target.hasAttribute('link-type') && ev.target.attributes["link-type"].value === "get-pdf") {
        ev.target.setAttribute("href", generatePdfLink(ev.target.attributes["guid"].value));
        updateNotifStatus(dispatch, getState, 2, notifId);
    }
    else if (ev.target.hasAttribute('link-type') && ev.target.attributes["link-type"].value === "get-export") {
        ev.target.setAttribute("href", generateExportLink(ev.target.attributes["export-id"].value));
        updateNotifStatus(dispatch, getState, 2, notifId);
    }
    else if (ev.target.hasAttribute('link-type') && ev.target.attributes["link-type"].value === "get-ml") {
        ev.target.setAttribute("href", generateMlExportLink(ev.target.attributes["req-id"].value));
        updateNotifStatus(dispatch, getState, 2, notifId);
    }
    else if (ev.target.hasAttribute('link-to')) {
        updateNotifStatus(dispatch, getState, 2, notifId);
        history.push(ev.target.attributes["link-to"].value);
    }
}

async function startConnection(dispatch, getState, force) {
    if (!getState().news.connOpen || force) {
        let hubConnection = new signalR.HubConnectionBuilder()
            .withUrl(getHostApi() + '/api/notifications?lang=' + getLanguage(), {
                accessTokenFactory: () => getAuthorization(false),
                skipNegotiation: true,
                transport: signalR.HttpTransportType.WebSockets
            })
            .build();

        //store for further use
        handlersSignalR.internal.getState = getState;
        handlersSignalR.internal.dispatch = dispatch;

        hubConnection
            .start()
            .then(() => {
                console.log('Connection started!');
                hubConnection.invoke('getConnectionId').then(signalWrap);
                if (isRepiWeb())
                    hubConnection.invoke('getMaxRepiNotificationId').then(signalWrap);
                else
                    hubConnection.invoke('getMaxNotificationId').then(signalWrap);
            })
            .catch(err => {
                console.log('Error while establishing connection :(');
                setTimeout(() => {
                    stopConnection(dispatch, getState);
                    ensureNotifications(dispatch, getState, true);
                }, 30000);
            });

        hubConnection.onclose(async () => {
            setTimeout(() => {
                stopConnection(dispatch, getState);
                if (getState().userContext.authentication && getState().userContext.authentication.isAuthorized) {
                    ensureNotifications(dispatch, getState, true);
                }
            }, 10000);
        });

        functionsSignalR.map(x => hubConnection.on(x.method, (msg) => {
            writeDebug('SignalR message', msg)
            if (msg === null || msg === undefined || msg.messageType.toLowerCase() != x.method.toLowerCase()) {
                writeErr('Empty or invalid data received for method:' + x.method, msg);
            } else if (msg.error !== null && msg.error !== undefined) {
                writeErr('Received error for method:' + x.method, msg);
            } else {
                x.handler(dispatch, getState()[x.stateItem], hubConnection, msg.data);
            }
        }))

        hubConnection.on('sendNotification', (receivedNotif) => {
            pushNotif(dispatch, getState, receivedNotif);
        });
        dispatch({ type: connectionStarted, hubConnection, connLang: getLanguage() });
    }
}

function signalWrap(msg) {
    writeDebug('SignalR message', msg)
    if (msg === null || msg === undefined) {
        writeErr('Empty data received');
        return;
    }
    if (msg.error !== null && msg.error !== undefined) {
        writeErr('Received error', msg);
        return
    }

    const hdata = handlersSignalR[(msg.messageType || '').toLowerCase()]
    if (hdata === null || hdata === undefined) {
        writeErr('No handler for method:' + msg.messageType, msg);
        return;
    }

    hdata.handler(handlersSignalR.internal.dispatch, handlersSignalR.internal.getState()[hdata.stateItem], msg.data);
}

function resetConnection(dispatch, getState) {
    var hubConnection = getState().news.hubConnection;
    if (hubConnection && getLanguage() != getState().news.connLang && getState().news.connOpen) {
        hubConnection
            .stop()
            .then(() => console.log('Connection stopped!'))
            .catch(err => console.log('Error while stopping connection :('));
    }
    else if (getState().news.dataNotif === null)
        ensureNotifications(dispatch, getState, false);
}

function logoutNotifs(dispatch, getState) {
    stopConnection(dispatch, getState);
    dispatch({ type: logoutNotifications });
}

function stopConnection(dispatch, getState) {
    var hubConnection = getState().news.hubConnection;
    if (hubConnection && getState().news.connOpen) {
        hubConnection.closedCallbacks = [];
        hubConnection
            .stop()
            .then(() => console.log('Connection stopped!'))
            .catch(_ => console.log('Error while stopping connection :('));
    }
    dispatch({ type: connectionStopped });
}

function generatePdfLink(id) { return `${getHostUrl()}/files/report-pdf/${id}`; }

function generateExportLink(id) { return `${getHostUrl()}/files/report-export/${id}`; }

function generateMlExportLink(id) { return `${getHostUrl()}/files/marketing-list/result/${id}`; }
